<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl title-text mx-2">监控</span>
          <dv-decoration-1 class="dv-dec-1" />
        </div>
      </div>
      <div id="webcam-list" class="d-flex jc-center my-video no-hover">
        <!-- <video id="videoPlayer"  autoplay style="width:560px;height:330px;"></video> -->
        <!-- 
          <div style="width:270px;height:330px;padding-left:10px;">
          <div style="position:absolute;width:18px;height:340px;background-color:#0f1325;opacity:1;left:280px;"></div>
          <iframe id="videoIframe" :src="videoSrc" style="width:265px;height:330px;overflow:hidden;border:1px solid #0f1325;"></iframe>
        </div> 
        -->
        
      </div>
    </div>
  </div>
</template>

<script>
import Transfer from "../utils/transfer";
// import Hls from 'hls.js';
var myWebcam = [], myWebcamEleArr = [], myWebcamShowId = null;

export default {
  data() {
    return {
      parentWidth: 270,
      parentHeight: 330,
      scrollMaskWidth:25,
      scrollMaskHeight: 340,
      scrollMaskLeft: 275,
      iframeWidth: 280,
      iframeHeight: 330,

      // width:260,
      // height:330,
      // videoSrc: "",
    }
  },
  components: {
  },
  created() {
    
  },
	mounted(){
    // let addr = localStorage.getItem('videoPlayAddr');
    // if(addr) {
    //   this.videoSrc = addr;
    // }
    // this.playHlsVideo("http://192.168.1.168/lives/4679/hls.m3u8");

    //调用函数
    var globalData = this.$store.state.globalData;
    if(globalData.webcamShow != 1) {
      //未配置摄像头，返回
      //防止报错，还需加载组件，报错：domObserver.disconnect is not a function at VueComponent.unbindDomResizeCallback
      return;
    }
    this.getWebcamList(),

    Transfer.$on('centerRight1', (msg) => {
      // console.log(msg);
      this.refreshWebcamShow();
    });

    // var iframe = document.getElementById('videoIframe');
    // iframe.height = iframe.contentWindow.document.body.scrollHeight + 'px';
	},
  beforeDestroy () {
   
  },
  methods: {
    refreshWebcamShow() {
      var index = myWebcamShowId;
      
      var globalData = this.$store.state.globalData;
      if(myWebcam.length == 0 || index == null || index > myWebcam.length)  return;
      if(globalData.curWebcamSerial == myWebcam[index].webcamSerial) return;

      var curShowEleId = myWebcam[index].eleId;
      var toShowEleId = "";
      for(var i = 0; i < myWebcam.length; i++) {
        if(globalData.curWebcamSerial == myWebcam[i].webcamSerial) {
          toShowEleId = myWebcam[i].eleId;
          myWebcamShowId = i;
        }
      }
      if(toShowEleId == '') return;
      
      document.getElementById(curShowEleId).setAttribute('style', "display:none;");
      document.getElementById(toShowEleId).setAttribute('style', "display:inline-block;");
    },
    getWebcamList() {
      var that = this;
      var globalData = this.$store.state.globalData;
      if(globalData.curGroupId == null && globalData.curGroupName == '') return;
      
      var resData = "?groupId=" + globalData.curGroupId + "&groupName=" + globalData.curGroupName;
      if(globalData.curGroupId == null) {
        resData = "?groupId=&groupName=" + globalData.curGroupName;
      }
      this.$httpApi.getWebCamList(resData, function(d) {
        // console.log(JSON.stringify(d)); 
        if(d == null || d.message == null || d.message.length == 0) return;

        var data = d.message;
        // if(globalData.accessToken == data[0].accessToken && myWebcamShowId != null) return;

        // //开始打开摄像头
        // globalData.accessToken = data[0].accessToken;
        
        //清空元素
        var webcamListEle = document.getElementById('webcam-list');
        webcamListEle.innerHTML = '';
        
        for(var i = 0; i < data.length; i++) {
          // //停止播放
          // if(myWebcam[i] != null && myWebcam[i].player != null) {
          //   myWebcam[i].player.stop();
          // }
          var eleId = "container" + i;
          var videoEleId = "video-container" + i;

          //记录数据， 用于刷新
          myWebcam[i] = {};
          myWebcam[i].deviceName = data[i].deviceName;
          myWebcam[i].uniqueWebcamSerial = data[i].uniqueDeviceSerial;
          myWebcam[i].webcamSerial = data[i].deviceSerial;
          myWebcam[i].decodeH5Url = data[i].decodeH5Url;
          // myWebcam[i].audioPlay = (data[i].audioPlay == 1 ? 1 : 0);
          // myWebcam[i].ptz = data[i].ptz;
          myWebcam[i].eleId = eleId;
          // myWebcam[i].reload = false; //true: 重新获取
          // myWebcam[i].replayer = false; //true: 重新播放

          //用于索引
          myWebcamEleArr[i] = videoEleId;


          //添加元素
          var node = document.createElement("div");
          node.setAttribute('id', eleId);
          node.setAttribute('style', "width:" + that.parentWidth + "px;height:" + that.parentHeight + "px;padding-left:10px;");

          // //遮罩层
          // var maskNode = document.createElement("div");
          // maskNode.setAttribute('id', videoEleId + "-mask");
          // maskNode.setAttribute('style', "position:absolute;width:" + that.width + "px;height:" + that.height + "px;z-index:998;background:#000000;opacity:0;");
          // maskNode.setAttribute('onclick', "cameraControlEvent(" + i + ")");
          // node.appendChild(maskNode);

          //导航栏遮挡
          var scrollMaskNode = document.createElement("div");
          scrollMaskNode.setAttribute('style', "position:absolute;background-color:#0f1325;opacity:1;width:" + that.scrollMaskWidth + "px;height:" + that.scrollMaskHeight + "px;left:" + that.scrollMaskLeft + "px;");
          node.appendChild(scrollMaskNode);

          var videNode = document.createElement("iframe");
          videNode.setAttribute('id', videoEleId);
          videNode.setAttribute('src', data[i].decodeH5Url);
          videNode.setAttribute('style', "width:" + that.iframeWidth + "px;height:" + that.iframeHeight + "px;padding-left:10px;overflow:hidden;border:1px solid #0f1325;");
          
          node.appendChild(videNode);


          if(globalData.curWebcamSerial == null || globalData.curWebcamSerial == '' || data[i].deviceSerial == globalData.curWebcamSerial) {
            node.setAttribute('style', "display:inline-block;");
            webcamListEle.appendChild(node);

            //记录当前播放监控序列号
            globalData.curUniqueWebcamSerial = data[i].uniqueDeviceSerial;
            globalData.curWebcamSerial = data[i].deviceSerial;
            myWebcamShowId = i;
          } else {
            node.setAttribute('style', "display:none;");
            webcamListEle.appendChild(node);
          }
          
        }

        globalData.webcamList = myWebcam;

      }, function(xhr) {
        console.log(xhr.responseText);
      });

    },

    // playHlsVideo(url) {
    //   const videoElement = document.getElementById('videoPlayer');
    //   if (!videoElement) return;
    //   // 清理旧实例
    //   if (this.hlsInstance) {
    //     this.hlsInstance.stopLoad();
    //     this.hlsInstance.detachMedia();
    //     this.hlsInstance.destroy();
    //   }
    //   // 配置并加载
    //   this.hlsInstance = new Hls({ enableWorker: true, lowLatencyMode: true });
    //   this.hlsInstance.on(Hls.Events.ERROR, (event, data) => {
    //     if (data.fatal) {
    //       switch (data.type) {
    //         case 'networkError':
    //           console.error('网络错误，请检查链接或CORS');
    //           break;
    //         case 'mediaError':
    //           console.error('媒体错误');
    //           break;
    //         default:
    //           console.error('未知错误', data);
    //           break;
    //       }
    //       this.hlsInstance.destroy();
    //       this.hlsInstance = null;
    //     }
    //   });
    //   this.hlsInstance.attachMedia(videoElement);
    //   this.hlsInstance.loadSource(url);
    // },

  }
	

};
</script>

<style lang="scss" scoped>
@import '../assets/scss/globalcss.scss';
#centerRight1 {
  $box-width: 300px;
  $box-height: 410px;
  padding: 16px;
  height: $box-height;
  min-width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .my-video {
    margin-top: 10px;
  }
  .no-hover {
    pointer-events: none;
  }
  
  .text {
    color: #c3cbde;
    font-size: 15px;
  }
  .dv-dec-1 {
    position: relative;
    width: 100px;
    height: 20px;
    top: -3px;
  }
  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;
    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>